import * as THREE from 'three'

export default function buildModifiedMaterial(uniforms){  
  const modifiedMaterial = new THREE.MeshStandardMaterial({
    color: uniforms.uColor1.value
  })
    
  modifiedMaterial.onBeforeCompile = (shader) => {
    // Uniforms
    shader.uniforms.uMouse = uniforms.uMouse
    shader.uniforms.uColor1 = uniforms.uColor1
    shader.uniforms.uColor2 = uniforms.uColor2
    shader.uniforms.uTime = uniforms.uTime

    shader.vertexShader = shader.vertexShader.replace(
      '#include <common>', 
      `
      #include <common>

      uniform vec3 uMouse;
      uniform float uTime;

      attribute vec3 aPos;
      attribute vec3 aCenter;

      varying float vDistance;
      `
    )
    shader.vertexShader = shader.vertexShader.replace(
      '#include <begin_vertex>',
      `
        #include <begin_vertex>

        // Ditance
        float distanceX = uMouse.x - aPos.x;
        float distanceY = uMouse.y - aPos.y;
        float distanceZ = uMouse.z - aPos.z;

        // Factor
        float factor = pow(1.8, -abs(distanceX) + -abs(distanceY) + -abs(distanceZ)) * 2.0;
        factor = pow(factor, 2.0);
        
        // Scale
        float distanceTime = (sin(uTime * 0.001) * 0.2) + 2.0;
        float scale = factor * distanceTime < 0.85 ? factor * distanceTime : 0.85;

        transformed.x += (aCenter.x - transformed.x) * scale;
        transformed.y += (aCenter.y - transformed.y) * scale;
        transformed.z += (aCenter.z - transformed.z) * scale;

        // Translate
        transformed.x += -distanceX * factor * distanceTime;
        transformed.y += -distanceY * factor * distanceTime;
        transformed.z += -distanceZ * factor * distanceTime;

        vDistance = (abs(distanceX) + abs(distanceY) + abs(distanceZ)) * 0.008;
      `
    )
    shader.fragmentShader = shader.fragmentShader.replace(
      `#include <common>`,
      `
        #include <common>
        uniform vec3 uColor1;
        uniform vec3 uColor2;  

        varying float vDistance;  
      `
    )
    shader.fragmentShader = shader.fragmentShader.replace(
      `vec4 diffuseColor = vec4( diffuse, opacity );`,
      `
        vec4 diffuseColor = vec4( mix(uColor1, uColor2, pow(vDistance * 50.0, 1.5)) * 0.8, opacity );
      `
    )
  }

  return modifiedMaterial
}
